import styled from "styled-components";

export const HorizontalSpacer = styled.div<{ spacing: number }>`
  width: 100%;
  height: ${(props) => `${props.spacing * 16}px`};
`;

export const VerticalSpacer = styled.div<{ spacing: number }>`
  width: ${(props) => `${props.spacing * 16}px`};
  height: auto;
`;
